import * as React from 'react';
import { renderItem } from './renderItem';

/**
 * Рендерит контент с пробелами между элементами
 */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var renderContent = function renderContent(content) {
  return content.map(function (item) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [renderItem(item), " "]
    });
  });
};